export const TagList = [
  {
    id: 0,
    icon: "💬",
    description: "장례 절차를 쉽게 설명해주셨어요",
  },
  {
    id: 1,
    icon: "🔍",
    description: "전문적으로 장례를 진행해주셨어요",
  },
  {
    id: 2,
    icon: "📝",
    description: "꼼꼼하게 장례를 진행해주셨어요",
  },
  {
    id: 3,
    icon: "✍️",
    description: "장례 견적 비교를 잘 해주셨어요",
  },
  {
    id: 4,
    icon: "❤️",
    description: "따뜻하고 친절하게 대해주셨어요",
  },
  {
    id: 5,
    icon: "👂",
    description: "경청하며 공감해주셨어요",
  },
  {
    id: 6,
    icon: "☺️",
    description: "든든한 조력자로 느껴졌어요",
  },
];

const 전문적인진행TagList = [
  {
    id: 0,
    icon: "🥰",
    description: "전문적이고 꼼꼼해요",
  },
  {
    id: 1,
    icon: "😐",
    description: "무난했어요",
  },
  {
    id: 2,
    icon: "😡",
    description: "아쉬운 점이 있었어요",
  },
];

const 진정성TagList = [
  {
    id: 0,
    icon: "🥰",
    description: "정성스럽고 따뜻하게 대해주셨어요",
  },
  {
    id: 1,
    icon: "😐",
    description: "보통이에요",
  },
  {
    id: 2,
    icon: "😡",
    description: "불친절하고 사무적이었어요",
  },
];

const 가격만족도TagList = [
  {
    id: 0,
    icon: "🥰",
    description: "만족해요",
  },
  {
    id: 1,
    icon: "😐",
    description: "보통이에요",
  },
  {
    id: 2,
    icon: "😡",
    description: "불만족스러워요",
  },
];

const 추가금TagList = [
  {
    id: 0,
    icon: "🥰",
    description: "추가금이 합리적이었어요",
  },
  {
    id: 1,
    icon: "😐",
    description: "추가금을 낼 만했어요",
  },
  {
    id: 2,
    icon: "😡",
    description: "추가금이 불편했어요",
  },
  {
    id: 3,
    icon: "❌",
    description: "추가금이 없었어요",
  },
];

export const newTagList = {
  "전문적인 진행": 전문적인진행TagList,
  진정성: 진정성TagList,
  "가격 만족도": 가격만족도TagList,
  추가금: 추가금TagList,
};
